import { render, staticRenderFns } from "./addNewClaimFbpComponent.vue?vue&type=template&id=603600ff&scoped=true"
import script from "./addNewClaimFbpComponent.vue?vue&type=script&lang=js"
export * from "./addNewClaimFbpComponent.vue?vue&type=script&lang=js"
import style0 from "./addNewClaimFbpComponent.vue?vue&type=style&index=0&id=603600ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603600ff",
  null
  
)

export default component.exports